import { BoxProps, Box as MuiBox } from "@mui/material";
import { forwardRef } from "react";

type Props = BoxProps;

export const Box = forwardRef<HTMLElement, Props>(({ children, ...props }: Props, ref) => {
  return (
    <MuiBox ref={ref} {...props}>
      {children}
    </MuiBox>
  );
});
Box.displayName = "Box";

export function AnyComponentBox<C extends React.ElementType>({ children, ...props }: BoxProps<C, { component?: C }>) {
  return <Box {...props}>{children}</Box>;
}
